import React, { useState } from "react";
import { api } from "../../services/api";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";

const DeleteAccountPage = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!email || !phone) {
      setError("Lütfen email ve telefon numaranızı girin.");
      return;
    }

    setIsSubmitting(true);
    try {
      // Sadece rakamları al, 10 haneye indir
      const rawDigits = phone.replace(/\D/g, "").slice(-10);
      const payload = {
        email: email.trim().toLowerCase(),
        phone: rawDigits,
      };

      const response = await api.post("/v1/mobil/delete-account", payload);
      setMessage(
        response?.data?.message ??
          "Eğer bilgilerinizle eşleşen bir mobil kullanıcı hesabı varsa silinmiştir."
      );
      setEmail("");
      setPhone("");
    } catch (err) {
      const apiMessage =
        err?.response?.data?.message ||
        "İşlem sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.";
      setError(apiMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-medical-50 to-blue-50 px-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-xl p-6 sm:p-8 border border-slate-100">
        <div className="text-center mb-6">
          <h1 className="text-xl sm:text-2xl font-semibold text-slate-900">
            Mobil Hesap Silme
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            EMT Mobil uygulaması hesabınızı silmek için lütfen kayıtlı{" "}
            <span className="font-medium text-slate-700">email</span> ve{" "}
            <span className="font-medium text-slate-700">
              telefon numaranızı
            </span>{" "}
            girin.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email adresi</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="ornek@emtambulans.com"
              required
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="phone">Telefon numarası</Label>
            <div className="flex items-center gap-2">
              <div className="px-3 py-2 rounded-md border bg-slate-50 text-slate-700 text-sm font-medium">
                +90
              </div>
              <Input
                id="phone"
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="555 123 4567"
                required
              />
            </div>
            <p className="text-xs text-slate-500">
              Sadece 10 haneli cep telefonu numaranızı girin (örn: 5551234567).
            </p>
          </div>

          {message && (
            <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-md px-3 py-2">
              {message}
            </div>
          )}

          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-100 rounded-md px-3 py-2">
              {error}
            </div>
          )}

          <Button
            type="submit"
            className="w-full mt-2"
            disabled={isSubmitting}
          >
            {isSubmitting ? "İşlem yapılıyor..." : "Hesabımı Sil"}
          </Button>
        </form>

        <p className="mt-4 text-xs text-center text-slate-400">
          Güvenlik nedeniyle sistem, hesap silme isteğinin sonucunu detaylı
          olarak göstermeden işlemi tamamlar.
        </p>
      </div>
    </div>
  );
};

export default DeleteAccountPage;


